import MediumHeadingBlock from './mediumHeadingBlock';

export default MediumHeadingBlock;
